import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

export const CREATE_ROLE_ASSIGNMENT_RESOURCE = 'createRoleAssignment';

const createRoleAssignmentService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_ROLE_ASSIGNMENT_RESOURCE,
      method: 'post',
      request: (
        appId,
        installationId,
        featureId,
        roleId,
        body,
        callback,
        rejectCallback,
        resource,
        t
      ) => ({
        url: apiRoutes.roleAppAssignments(appId, installationId, featureId, roleId),
        body,
        meta: {
          addToOtherList: {
            resource,
          },
          callback,
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createRoleAssignmentFailed'),
            onSuccessMessage: t('createRoleAssignmentSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default createRoleAssignmentService;
